import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const BoxSelectionFunnelStyled = styled.div`
  .wrapper_funnel {
    display: flex;
    width: 100%;
    margin: 0 auto;
    padding: 10px;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
  }

  /* Tarjeta compacta (32 px, el alto de los chips) a la altura de la fila de fases */
  .title-funnel {
    display: flex;
    width: fit-content;
    height: 32px;
    margin-top: 15px; /* el mismo padding superior que .group-phases */
    padding: 0 12px 0 4px;
    align-items: center;
    flex-direction: row;
    border-radius: 999px;
    background: ${tokens.color.background.default};
    border: 1px solid ${tokens.color.border.subtle};

    .wrapper-title {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-direction: row;
      justify-content: center;

      span {
        color: ${tokens.color.text.primary};
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  /* Alineado con la fila de estados (chips de 32 px + 15 px de hueco) y con el texto del título */
  .title-current-state {
    width: auto;
    margin-top: 15px;
    height: 32px;
    display: flex;
    align-items: center;
    padding-left: 36px;

    p {
      margin: 0;
      color: ${tokens.color.text.tertiary};
      font-size: 14px;
      font-weight: 500;
    }
  }

  .container-icon {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${tokens.color.background.light};
  }

  .container {
    display: flex;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }

  .wrapper-phases {
    display: flex;
    align-items: center;
    overflow-x: auto;
    padding: 0 10px;
    box-sizing: border-box;
    justify-content: flex-start;

    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(63, 67, 80, 0.24);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  .container-titles {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .group-phases {
    display: flex;
    padding: 15px 2px;
    align-items: center;
    gap: 10px;
    color: ${tokens.color.text.primary};
    text-align: center;
    font-size: 13px;
    font-weight: 500;

    .title-phases {
      display: flex;
      font-size: 13px;
      font-weight: 500;
    }
  }
  .phases-container {
    display: flex;
    gap: 25px;
    align-content: flex-start;
    position: relative;
  }

  .phase {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    min-height: auto;
    width: 100%;
    z-index: 1;
  }

  .status-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    width: 100%;
  }

  .MuiChip-label {
    font-size: 12px !important;
    font-weight: 500 !important;
    font-family: Poppins !important;
  }

  .line-horizontal {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    height: 1px;
    width: calc(96% - 10px);
    background-color: #e0e0e0;
    margin-left: 2px;
    position: absolute;
    margin: 15px;
  }

  @media (max-width: 1200px) {
    .container-title {
      display: none;
    }
  }
`

export default BoxSelectionFunnelStyled
